import './FleetFifty.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";
import ScrollingAnounce from "../../../Component/GetAroundpage/ScrollingAnounce/ScrollingAnounce";
import EasySetup from "../../../Component/GetAroundpage/EasySetup/EasySetup";
import { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
 

const FleetFifty = ()=> {

     
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
          setTimeout(() => {
            const element = document.querySelector(hash);
            if (element) {
              const headerOffset = 80; // Adjust according to your header height
              const elementPosition = element.getBoundingClientRect().top + window.scrollY;
              window.scrollTo({
                top: elementPosition - headerOffset,
                behavior: "smooth",
              });
            }
          }, 100); // Delay to ensure DOM is loaded
        }
      }, []);
      

    useEffect(() => {
      setIsClient(true);
    }, []);
  
    if (!isClient) return null;
   


    return (
        <>
            <AIheader/>

            {/* START bannerFleetMain */}
            <section className="bannerFleetMain">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-5">
                            <div className="bannerFleetLeft">
                                <h1>Rentid Supports<br/> Fleets with<br/> <span>26-50 Vehicles</span></h1>
                                <h4>Scaling to a High-Performance Fleet</h4>
                                <p>Efficiency and scalability become critical factors in maintaining profitability. Rentid provides fleet owners with cutting-edge tools, AI-driven automation, and scalable insurance solutions to ensure seamless operations and sustainable growth.</p>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="bannerFleetRight">
                                <figure>
                                    <img className='img-fluid' src="/img/Fleet/fleet_fifty_banner.webp" alt="26-50 Vehicles"/>
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END bannerCarRentalMain */}

            {/* START scalingFleetsMain */}
            <section className="scalingFleetsMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="scalingFleetsHead">
                                <h2>Scaling Fleets Choose Rentid</h2>
                                <p>Operational, Administrative, & Logistical Automation </p>
                            </div>
                        </div>
                    </div>


                    <div className="scalingFleetsOuter">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="scalingFleetsLeft">
                                    <div className="scalingFleetsInner">
                                        <figure><img className="img-fluid" src="/img/Fleet/car_white.svg" alt="Fleet-Wide Automation"/></figure>
                                        <h3>Fleet-Wide <br/>Automation</h3>
                                        <p>Manage reservations, track vehicle performance, and optimize pricing with minimal manual effort.</p>
                                    </div>
                                    <div className="scalingFleetsInner">
                                        <figure><img className="img-fluid" src="/img/Fleet/security_white.svg" alt="Comprehensive Fleet Protection"/></figure>
                                        <h3>Comprehensive Fleet Protection</h3>
                                        <p>RentShield™ provides full-scale insurance options, covering every vehicle in your fleet.</p>
                                    </div>

                                    <div className="scalingFleetsInner">
                                        <figure><img className="img-fluid" src="/img/Fleet/money_white.svg" alt="Revenue Optimization"/></figure>
                                        <h3>Revenue Optimization</h3>
                                        <p>Adjust pricing dynamically using market analytics to ensure profitability.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="scalingFleetsRight">
                                    <div className="scalingFleetsInner">
                                        <figure><img className="img-fluid" src="/img/Fleet/rentid_icon.svg" alt="AI-Driven Guest Screening"/></figure>
                                        <h3>AI-Driven Guest Screening</h3>
                                        <p>Reduce risk with RentID renter verification and automated approval workflows.</p>
                                    </div>
                                    <div className="scalingFleetsInner">
                                        <figure><img className="img-fluid" src="/img/Fleet/location_white.svg" alt="Multi-Location Management"/></figure>
                                        <h3>Multi-Location Management</h3>
                                        <p>Expand across cities while<br/> maintaining centralized control <br/> over pricing, availability, and compliance.</p>
                                    </div>

                                    <div className="scalingFleetsInner">
                                        <figure><img className="img-fluid" src="/img/Fleet/headset_white.svg" alt="Dedicated Business Support"/></figure>
                                        <h3>Dedicated Business Support</h3>
                                        <p>Work directly with your Rentid Success Manager for fleet growth strategies and operational improvements.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END scalingFleetsMain */}


            {/* STRAT dedicatedSuccessMain */}
            <section className='dedicatedSuccessMain'>
                <div className='container'>
                    {/* row start */}
                    <div className="row justify-content-center">
                        <div className="col-lg-9">
                            <div className="dedicatedSuccessHead">
                                <h2>Dedicated Success Management</h2>
                                <p>Fleet owners in this category receive a Rentid Success Manager,<br/> a dedicated expert who helps streamline your operations.</p>
                            </div>
                        </div>
                    </div>
                    {/* row end */}

                    {/* row start */}
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="dedicatedSuccessInner">
                                <div className="dedicatedSuccessImage">
                                    <img className="img-fluid" src="/img/Fleet/dedicatedSuccess_1.png" alt="Profile Setup"/>
                                </div>
                                <div className="fleetsDataAnounce">
                                    <figure>
                                        <img className="img-fluid" src="/img/Solutions/growing.svg" alt="Profile Setup"/>
                                    </figure>
                                    <h3>Profile Setup</h3>
                                    <p>Ensuring your fleet profile is fully optimized on Rentid’s platform.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="dedicatedSuccessInner">
                                <div className="dedicatedSuccessImage">
                                    <img className="img-fluid" src="/img/Fleet/dedicatedSuccess_2.webp" alt="Vehicle Onboarding"/>
                                </div>
                                <div className="fleetsDataAnounce">
                                    <figure>
                                        <img className="img-fluid" src="/img/Solutions/car.svg" alt="Vehicle Onboarding"/>
                                    </figure>
                                    <h3>Vehicle Onboarding</h3>
                                    <p>Helping you add and configure all vehicles with the right pricing and policies.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="dedicatedSuccessInner">
                                <div className="dedicatedSuccessImage">
                                    <img className="img-fluid" src="/img/Fleet/dedicatedSuccess_3.webp" alt="Ongoing Support"/>
                                </div>
                                <div className="fleetsDataAnounce">
                                    <figure>
                                        <img className="img-fluid" src="/img/Solutions/shield.svg" alt="Ongoing Support"/>
                                    </figure>
                                    <h3>Ongoing Support</h3>
                                    <p>Providing guidance on fleet performance, operational efficiency, and strategic scaling.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* row end */}

                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="dedicatedSuccessBottom">
                                <p>With this <span>personalized support</span>, large fleet owners can maximize their 
                                    revenue potential and enhance operational efficiency without the guesswork.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END dedicatedSuccessMain */}


            {/* START gigDeliveryMain */}
            <section className='gigDeliveryMain gigFleetFiveMain'>
                <div className='container-fluid'>
                    <div className="row jusify-content-center align-items-center">
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryLeft"> 
                                <h2>Seamless Growth<br/> for Expanding Fleets</h2>
                                <p>Unlock advanced tools, dedicated support, and automation designed to help you manage, protect, and grow your fleet with ease. Whether you're optimizing daily operations or planning for future expansion, we provide the technology and resources to help you thrive.</p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12 gx-0">
                            <div className="gigDeliveryRight">
                                <img className='img-fluid' src="/img/Fleet/seamless_growth.webp" alt="Seamless Growth for Expanding Fleets"/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END gigDeliveryMain */}


  



            {/* START choiceFormerMain */}
            <section  className="choiceFormerMain choiceDesktopMain fleetFiveChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>How Rentid’s Core Products Support Growing Fleets</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <ul className="nav nav-tabs main-tabs-ai">
                                <li className="nav-item">
                                    <a className="nav-link active" data-bs-toggle="tab" href="#choiceFormer_1">
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_2">
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_3">
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_4">
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent AI"/>rent<span>AI</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_5">
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link" data-bs-toggle="tab" href="#choiceFormer_6">
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </a>
                                </li>
                            </ul>
                        
                            <div className="tab-content">
                                {/* START Tab 1 */}
                                <div className="tab-pane active" id="choiceFormer_1">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent Direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>End-to-End Fleet Automation</h3>
                                                    <h4>Seamlessly manage every aspect of your rental operation with AI-powered automation and centralized control.</h4>
                                                    <ul>
                                                        <li>
                                                            <h6><span>Effortless Booking & Reservation Management</span> – Handle high volumes of reservations with an intuitive dashboard.</h6>
                                                        </li>
                                                        <li>
                                                            <h6><span>Automated Pricing Adjustments</span> – Set rules for peak demand, seasonal fluctuations, and multi-location pricing.</h6>
                                                        </li>
                                                        <li>
                                                            <h6><span>Fleet-Wide Calendar Control</span> – Optimize availability across multiple locations while preventing double bookings.</h6>
                                                        </li>
                                                        <li>
                                                            <h6><span>Advanced Performance Analytics</span> – Monitor utilization rates, pricing trends, and profitability at scale.</h6>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* END Tab 1 */}

                                {/* START Tab 2 */} 
                                <div className="tab-pane fade" id="choiceFormer_2">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rent Id"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Enhanced Renter Screening & Security</h3>
                                                    <h4>Ensure safety and reliability with AI-powered verification tools that protect your fleet.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>DriverIQ™ Risk Assessment</h5>
                                                            <small>Score renters based on rental history, behavior patterns, and fraud detection.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated Approval Settings</h5>
                                                            <small>Customize renter acceptance criteria to filter high-risk users.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Incident Reporting & Tracking</h5>
                                                            <small>Keep a record of past incidents to prevent repeat issues.</small>
                                                        </li>
                                                        <li>
                                                            <h5>AI-Powered Fraud Detection</h5>
                                                            <small>Identify and block suspicious renters before they complete a booking.</small>
                                                        </li>
                                                    </ul>
                                                </div>                                           
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentid">Learn About RentID
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 2 */}

                                {/* START Tab 3 */}
                                <div className="tab-pane fade" id="choiceFormer_3">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Scalable Fleet Insurance Solutions</h3>
                                                    <h4>Protect your growing fleet with flexible and cost-effective insurance tailored to your business model.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Fleet-Wide Coverage</h5>
                                                            <small>Ensure every vehicle in your fleet has full protection at competitive rates.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Per-Trip or Monthly Policies</h5>
                                                            <small>Choose coverage based on usage or opt for full-time protection.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Integrated Claims Management</h5>
                                                            <small>File and track insurance claims directly from the Rentid dashboard.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Customizable Risk Policies</h5>
                                                            <small>Adjust coverage limits and deductibles based on fleet needs.</small>
                                                        </li>
                                                    </ul>
                                                </div>                                           
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 3 */}

                                {/* START Tab 4 */} 
                                <div className="tab-pane fade" id="choiceFormer_4">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent ai"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>AI-Powered Customer Interaction & Automation</h3>
                                                    <h4>Eliminate manual customer service tasks and provide instant AI-driven support.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Automated Renter Assistance</h5>
                                                            <small>AI chatbot handles renter questions, reservation changes, and policy clarifications.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Smart Contract Execution</h5>
                                                            <small>Auto-generate rental agreements with renter-specific terms and digital signing.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Late Return & Damage Handling</h5>
                                                            <small>AI identifies late returns and damage claims, streamlining resolution.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Escalation to Live Agents</h5>
                                                            <small>Complex renter issues are escalated to your team for direct handling.</small>
                                                        </li>
                                                    </ul>
                                                </div>    
                                               <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 4 */}

                                {/* START Tab 5 */}
                                <div className="tab-pane fade" id="choiceFormer_5">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Strategic Growth & Revenue Optimization</h3>
                                                    <h4>Leverage data-driven insights and expert consultation to expand operations and increase profitability.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Dynamic Pricing Strategies</h5>
                                                            <small>Adjust rates based on market demand and fleet performance.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Revenue Forecasting & Financial Planning</h5>
                                                            <small>Gain insights into fleet ROI, operational costs, and expansion feasibility.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Marketing & Acquisition Tools</h5>
                                                            <small>Increase bookings through targeted digital campaigns and remarketing strategies.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Dedicated Growth Consultation</h5>
                                                            <small>Work with your Rentid Success Manager to develop a scalable growth plan.</small>
                                                        </li>
                                                    </ul>
                                                </div>  
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 5 */}


                                {/* START Tab 6 */} 
                                <div className="tab-pane fade" id="choiceFormer_6">
                                    <div className='row align-items-center'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rent academy"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceFormerRight'>
                                                <div className='choiceFormerTop'>
                                                    <h3>Advanced Education & Fleet Networking</h3>
                                                    <h4>Gain expert insights and connect with experienced fleet operators to refine your business strategy.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Scaling Strategies & Industry Trends</h5>
                                                            <small>Stay informed about the latest rental industry best practices.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Exclusive Webinars & Workshops</h5>
                                                            <small>Learn from industry leaders on fleet management, pricing, and compliance.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Community Networking & Peer Learning</h5>
                                                            <small>Engage with fleet owners who have successfully scaled beyond 50 vehicles.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Operational Playbooks for Scaling</h5>
                                                            <small>Access step-by-step guides on expanding into new markets.</small>
                                                        </li>
                                                    </ul>
                                                </div>  
                                                <div className='choiceFormerRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                                {/* END Tab 6 */}
                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceFormerMain */}

            {/* START choiceMobileMain */}
            <section  className="choiceFormerMain choiceMobileMain fleetFiveChoiceMain"> 
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="headChoiceFormer">
                                <h2>How Rentid’s Core Products Support Growing Fleets</h2>
                                <p>The only rental platform you’ll ever need</p>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <div className="choiceAccordian">
                            <Accordion defaultActiveKey="0">
                                {/* start 1 */}
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_direct_icon.svg" alt="rent direct"/>rent<span>direct</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentDirectLeft.png" alt="rent direct"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'>
                                                <h3>End-to-End Fleet Automation</h3>
                                                <h4>Seamlessly manage every aspect of your rental operation with AI-powered automation and centralized control.</h4>
                                                <ul>
                                                    <li>
                                                        <h6><span>Effortless Booking & Reservation Management</span> – Handle high volumes of reservations with an intuitive dashboard.</h6>
                                                    </li>
                                                    <li>
                                                        <h6><span>Automated Pricing Adjustments</span> – Set rules for peak demand, seasonal fluctuations, and multi-location pricing.</h6>
                                                    </li>
                                                    <li>
                                                        <h6><span>Fleet-Wide Calendar Control</span> – Optimize availability across multiple locations while preventing double bookings.</h6>
                                                    </li>
                                                    <li>
                                                        <h6><span>Advanced Performance Analytics</span> – Monitor utilization rates, pricing trends, and profitability at scale.</h6>
                                                    </li>
                                                </ul>

                                                <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentdirect">Learn About RentDirect
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 2 */}
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_id_icon.svg" alt="rent id"/>rent<span>ID</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentIdLeft.png" alt="rent id"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Enhanced Renter Screening & Security</h3>
                                                    <h4>Ensure safety and reliability with AI-powered verification tools that protect your fleet.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>DriverIQ™ Risk Assessment</h5>
                                                            <small>Score renters based on rental history, behavior patterns, and fraud detection.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Automated Approval Settings</h5>
                                                            <small>Customize renter acceptance criteria to filter high-risk users.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Incident Reporting & Tracking</h5>
                                                            <small>Keep a record of past incidents to prevent repeat issues.</small>
                                                        </li>
                                                        <li>
                                                            <h5>AI-Powered Fraud Detection</h5>
                                                            <small>Identify and block suspicious renters before they complete a booking.</small>
                                                        </li>
                                                    </ul>
                                                                                        
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentid">Learn About RentID
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 3 */}
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_shield_icon.svg" alt="rent shield"/>rent<span>shield</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentShieldLeft.png" alt="rent shield"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                <h3>Scalable Fleet Insurance Solutions</h3>
                                                    <h4>Protect your growing fleet with flexible and cost-effective insurance tailored to your business model.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Fleet-Wide Coverage</h5>
                                                            <small>Ensure every vehicle in your fleet has full protection at competitive rates.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Per-Trip or Monthly Policies</h5>
                                                            <small>Choose coverage based on usage or opt for full-time protection.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Integrated Claims Management</h5>
                                                            <small>File and track insurance claims directly from the Rentid dashboard.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Customizable Risk Policies</h5>
                                                            <small>Adjust coverage limits and deductibles based on fleet needs.</small>
                                                        </li>
                                                    </ul>
                                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentshield">Learn About RentShield
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 4 */}
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_ai_icon.svg" alt="rent AI"/>rent<span>AI</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAiLeft.png" alt="rent AI"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'>
                                                    <h3>AI-Powered Customer Interaction & Automation</h3>
                                                    <h4>Eliminate manual customer service tasks and provide instant AI-driven support.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Automated Renter Assistance</h5>
                                                            <small>AI chatbot handles renter questions, reservation changes, and policy clarifications.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Smart Contract Execution</h5>
                                                            <small>Auto-generate rental agreements with renter-specific terms and digital signing.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Late Return & Damage Handling</h5>
                                                            <small>AI identifies late returns and damage claims, streamlining resolution.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Escalation to Live Agents</h5>
                                                            <small>Complex renter issues are escalated to your team for direct handling.</small>
                                                        </li>
                                                    </ul>
                                               
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentai">Learn About RentAI
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 5 */}
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_success_icon.svg" alt="rent success"/>rent<span>success</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className='row'>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileLeft'>
                                                <figure>
                                                    <img className="img-fluid" src="/img/AnoucementPage/rentSuccessLeft.png" alt="rent success"/>
                                                </figure>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                            <div className='choiceMobileRight'> 
                                                <h3>Strategic Growth & Revenue Optimization</h3>
                                                <h4>Leverage data-driven insights and expert consultation to expand operations and increase profitability.</h4>
                                                <ul>
                                                    <li>
                                                        <h5>Dynamic Pricing Strategies</h5>
                                                        <small>Adjust rates based on market demand and fleet performance.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Revenue Forecasting & Financial Planning</h5>
                                                        <small>Gain insights into fleet ROI, operational costs, and expansion feasibility.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Marketing & Acquisition Tools</h5>
                                                        <small>Increase bookings through targeted digital campaigns and remarketing strategies.</small>
                                                    </li>
                                                    <li>
                                                        <h5>Dedicated Growth Consultation</h5>
                                                        <small>Work with your Rentid Success Manager to develop a scalable growth plan.</small>
                                                    </li>
                                                </ul>
                                        
                                                 <div className='choiceMobileRightBtn'>
                                                    <a className="btn btnTransparent_4" href="/rentsuccess">Learn About RentSuccess
                                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                                    </a>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>

                                {/* start 6 */}
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <img src="/img/AnoucementPage/rent_academy_icon.svg" alt="rent academy"/>rent<span>academy</span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className='row'>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileLeft'>
                                                    <figure>
                                                        <img className="img-fluid" src="/img/AnoucementPage/rentAcademyLeft.png" alt="rent academy"/>
                                                    </figure>
                                                </div>
                                            </div>
                                            <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                                                <div className='choiceMobileRight'> 
                                                    <h3>Advanced Education & Fleet Networking</h3>
                                                    <h4>Gain expert insights and connect with experienced fleet operators to refine your business strategy.</h4>
                                                    <ul>
                                                        <li>
                                                            <h5>Scaling Strategies & Industry Trends</h5>
                                                            <small>Stay informed about the latest rental industry best practices.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Exclusive Webinars & Workshops</h5>
                                                            <small>Learn from industry leaders on fleet management, pricing, and compliance.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Community Networking & Peer Learning</h5>
                                                            <small>Engage with fleet owners who have successfully scaled beyond 50 vehicles.</small>
                                                        </li>
                                                        <li>
                                                            <h5>Operational Playbooks for Scaling</h5>
                                                            <small>Access step-by-step guides on expanding into new markets.</small>
                                                        </li>
                                                    </ul>
                                
                                                    <div className='choiceMobileRightBtn'>
                                                        <a className="btn btnTransparent_4" href="/rentacademy">Learn About RentAcademy
                                                            <img src="/img/arrow_spl.svg" alt="icon"/>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* end 6 */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </section>
            {/* END choiceMobileMain */}


            {/* START industryFleetFiveMain */}
            <section className='industryFleetFiveMain'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <div className='industryFleetFiveHead'>
                                <h6>INDUSTRY SOLUTIONS</h6>
                                <h2>Solving Car Rental for Everyone</h2>
                                <p>Rentid makes car rental easy and simple for everyone, no matter your industry. 
                                Optimize every rental with a powerful, all-in-one back-office solution. Automate 
                                workflows, simplify management, and resolve issues seamlessly—so you can 
                                grow your business.</p>
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-rental">
                                    <img className='img-fluid' src="/img/Fleet/car_black.svg" alt="Car Rental"/>
                                    <h3>Car Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/car-sharing">
                                    <img className='img-fluid' src="/img/Fleet/refresh_black.svg" alt="Car Sharing"/>
                                    <h3>Car Sharing</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                            <a href="/ride-sharing">
                                <img className='img-fluid' src="/img/Fleet/user_switch_black.svg" alt="Ride Share"/>
                                <h3>Ride Share</h3>
                            </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/delivery">
                                    <img className='img-fluid' src="/img/Fleet/spoon_black.svg" alt="Delivery Drivers"/>
                                    <h3>Delivery Drivers</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 2 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/auto-dealerships">
                                    <img className='img-fluid' src="/img/Fleet/car_parking_black.svg" alt="Auto Dealerships"/>
                                    <h3>Auto Dealerships</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/service-repair">
                                    <img className='img-fluid' src="/img/Fleet/wrench_black.svg" alt="Service & Repair"/>
                                    <h3>Service & Repair</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="/vacation-rental">
                                    <img className='img-fluid' src="/img/Fleet/house_black.svg" alt="Vacation Rental"/>
                                    <h3>Vacation Rental</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/hotel_black.svg" alt="Hotel & Resort"/>
                                    <h3>Hotel & Resort</h3>
                                </a>
                            </div>
                        </div>

                        {/* START 3 */}
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/building_black.svg" alt="Property Mgmt"/>
                                    <h3>Property Mgmt</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/tie_black.svg" alt="Corporate"/>
                                    <h3>Corporate</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/pentagon_black.svg" alt="Government"/>
                                    <h3>Government</h3>
                                </a>
                            </div>
                        </div>
                        <div className='col-xl-3 col-lg-4 col-md-6 col-sm-6'>
                            <div className='industryFleetFiveInner'>
                                <a href="#">
                                    <img className='img-fluid' src="/img/Fleet/teacher_black.svg" alt="Education"/>
                                    <h3>Education</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryFleetFiveMain */}

            {/* START industryTrustMain */}
            <section className="industryTrustMain">
                <div className="container">
                    <div className='industryTrustOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-5 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustLeft'>
                                    <h2>Industry trust<span> and transparency</span> </h2>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-12 col-sm-12 col-12'>
                                <div className='industryTrustRight'>
                                    <ul>
                                        <li>
                                            <img className="img-fluid" width="140px" src="/img/AnoucementPage/industryTrust_1.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="164px" src="/img/AnoucementPage/industryTrust_2.png" alt="Industry trust and transparency" />
                                        </li>
                                        <li>
                                            <img className="img-fluid" width="146px" src="/img/AnoucementPage/industryTrust_3.png" alt="Industry trust and transparency" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END industryTrustMain */}
            
 
 
            <EasySetup/> 

            {/* START expSolutionsMain */}
            <section className="expSolutionsMain expSolutions_50_Main">
                <div className="container">
                    <div className='expSolutionsOuter'>
                        <div className='row align-items-center'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                <div className='expSolutionsInner'>
                                    <h2>Explore Rentid’s Solutions for<br/> Fleets with 100+ Vehicles</h2>
                                    <a className="btn btnWhite" href="/fleet-100">Learn More</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END expSolutionsMain */}

            <ScrollingAnounce/>
            <Footer/>
        </>
    )
}

export default FleetFifty;